import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=0f6f6cce&"
import script from "./FieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./FieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports